import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "passenger-select" }
const _hoisted_2 = { class: "passenger-select__alert" }
const _hoisted_3 = { class: "passenger-select" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TripPassengerSelectQuantity = _resolveComponent("TripPassengerSelectQuantity")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!
  const _component_BaseSection = _resolveComponent("BaseSection")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showShareholderPassengerBox)
      ? (_openBlock(), _createBlock(_component_BaseSection, {
          key: 0,
          errors: _ctx.v$.booking.$errors,
          disabled: !_ctx.isSectionEnable || _ctx.disabled
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _cache[0] || (_cache[0] = _createElementVNode("header", null, [
                _createElementVNode("h4", null, "Passengers eligible for shareholder discount")
              ], -1)),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shareholderPassengerTypes, (passengerType) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: passengerType.type
                  }, [
                    _createVNode(_component_TripPassengerSelectQuantity, {
                      type: passengerType.type,
                      name: passengerType.name,
                      ageSuffix: passengerType.ageSuffix
                    }, null, 8, ["type", "name", "ageSuffix"])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_BaseAlert, {
                  type: "info",
                  message: _ctx.shareholderAlert
                }, null, 8, ["message"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["errors", "disabled"]))
      : _createCommentVNode("", true),
    _createVNode(_component_BaseSection, {
      errors: _ctx.v$.booking.$errors,
      disabled: !_ctx.isSectionEnable || _ctx.disabled
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("header", null, [
            _createElementVNode("h4", null, "Passengers")
          ], -1)),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.passengerTypes, (passengerType) => {
              return (_openBlock(), _createElementBlock("li", {
                key: passengerType.type
              }, [
                _createVNode(_component_TripPassengerSelectQuantity, {
                  type: passengerType.type,
                  name: passengerType.name,
                  ageSuffix: passengerType.ageSuffix
                }, null, 8, ["type", "name", "ageSuffix"])
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["errors", "disabled"])
  ], 64))
}